import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';
registerModuleCatalog(
  'bank-account-product',
  (locale: Locale) => import(`./locales/${locale}.po`),
  { eager: true },
);
export const loadBankAccountProductMessages = () => ensureModuleMessages('bank-account-product');
